import yellow from "@material-ui/core/colors/yellow"
import { hexToRgbA } from "../../utils/color"

const styles = theme => ({
  card: {
    // width: 300
  },
  media: {
    height: "100%",
    width: "200px",
    // paddingTop: "56.25%", // 16:9
    position: "relative",
  },
  imageOverlay: {
    "&:before": {
      position: "absolute",
      top: "0",
      left: "0",
      bottom: "0",
      right: "0",
      color: "white",
      textTransform: "uppercase",
      fontWeight: "500",
      fontFamily: "Roboto",
      fontSize: "24px",
      padding: "12px",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "center",
    },
  },
  imageOverlayPreferred: {
    "&:before": {
      content: "'Preferred'",
      background: `linear-gradient(transparent, ${hexToRgbA(
        yellow[700],
        0.75
      )})`,
    },
  },
  imageOverlayDoNotUse: {
    "&:before": {
      content: "'Do Not Use'",
      background: `linear-gradient(transparent, ${hexToRgbA(
        theme.palette.secondary.main,
        0.75
      )})`,
    },
  },
  cardHeadline: {
    fontSize: "1.3em",
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "100%",
    textOverflow: "ellipsis",
    marginBottom: 0,
  },
  cardContent: {
    width: "65%",
    textAlign: "left",
    minHeight: 170,
    display: "flex",
    flexDirection: "column",
  },
  checkBox: {
    position: "absolute",
    top: 0,
    left: 0,
  },
  checkBoxRoot: {
    color: "#fff",
  },
  checkBoxChecked: {
    color: ["#fff", "!important"],
  },
  moreButton: {
    position: "absolute",
    top: 0,
    right: 0,
    color: "#fff",
  },
  primaryPlace: {
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  },
  placeName: {
    fontSize: 10,
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  placeIcon: {
    width: "0.7em",
    marginLeft: -2,
  },
  rating: {
    marginLeft: -theme.spacing(1),
  },
  popoverTitle: {
    fontWeight: 600,
  },
  listItem: {
    padding: [0, "!important"],
  },
  listText: {
    color: "rgba(0,0,0,0.35)",
  },
  bottomArea: {
    display: "flex",
    alignItems: "flex-end",
    flexGrow: 1,
  },
  messageButton: {
    marginRight: theme.spacing(1),
  },
  positionsArea: {
    textAlign: "right",
    marginLeft: 16,
  },
  positions: {
    fontSize: "1rem",
    fontFamily: "Oswald",
    fontWeight: 300,
    marginBottom: 0,
  },
  positionRate: {
    fontWeight: 500,
    fontFamily: '"Oswald"',
    marginBottom: 0,
    lineHeight: "1.1em",
  },
  fab: {
    width: 44,
    height: 44,
  },
  fabSelected: {
    backgroundColor: "#455a64",
  },
  fabIcon: {
    transition: theme.transitions.create("transform", {
      easing: theme.transitions.easing.sharp,
    }),
  },
  fabIconAnimated: {
    transform: "rotate(45deg)",
  },
  badge: {
    color: "#fff",
    backgroundColor: "#455a64",
    right: -20,
    width: 20,
    height: 20,
  },
  icons: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.grey[400],
    justifyContent: "space-between",
    width: "80px",
  },
  boxIcon: {
    fontSize: "1.3em",
  },
  vehicleIcon: {
    fontSize: "1.1em",
  },
  iconDisabled: {
    color: theme.palette.grey[200],
    cursor: ["default", "!important"],
  },
  popover: {
    pointerEvents: "none",
  },
  popoverPaper: {
    padding: theme.spacing(2),
  },
  modal: {
    position: "absolute",
    width: "50%",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    outline: "none",
    [theme.breakpoints.down("md")]: {
      width: "65%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "80%",
    },
  },
  trigger: {
    cursor: "pointer",
  },
  badgeWrapper: {
    position: "absolute",
    bottom: -12,
    right: 30,
    height: 45,
    width: 45,
    boxShadow:
      "0px 0px 0px -1px rgba(0, 0, 0, 0.1), 0px 2px 16px 0px rgba(0, 0, 0, 0.1), 0px 0px 2px 0px rgba(0, 0, 0, 0.1)",
    backgroundColor: theme.palette.secondary.main,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 2,
  },
  badgeImage: {
    height: 35,
  },
  verticalSlate: {
    display: "flex",
    flexDirection: "row",
  },
  positionText: {
    fontSize: "0.7rem",
    fontWeight: 800,
  },
  marginLeft: {
    marginLeft: theme.spacing(5),
  },
})

export default styles
